import { Router, NavigationCancel, NavigationEnd, NavigationError, NavigationStart } from '@angular/router';
import { FuseLoadingService } from '@fuse/services/loading';

const NAV_KEY = 'router-navigation';

/**
 * ERP #385: the Fuse loading bar only tracked HTTP calls, so a navbar click showed nothing while the lazy
 * route chunk loaded. Count the navigation as one more pending "request": the bar shows from NavigationStart
 * and, since the page's first data calls start before NavigationEnd, stays up until they finish too.
 */
export function trackNavigationLoading(router: Router, loading: FuseLoadingService): void {
    router.events.subscribe((e) => {
        if (e instanceof NavigationStart) loading._setLoadingStatus(true, NAV_KEY);
        else if (e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError)
            loading._setLoadingStatus(false, NAV_KEY);
    });
}
